import Vue from 'vue'
import Vuex from 'vuex'

import persistedState from 'vuex-persistedstate'

// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context('./modules', true, /\.js$/)

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

Vue.use(Vuex)
export const store = new Vuex.Store({
  modules,
  plugins: [
    persistedState({
      reducer(val) {
        return {
          selectedWorkList: val.selectedWorkList,
          classroomTaskList: val.classroomTaskList,  // 课堂任务清单持久化
          examWorkList: val.examWorkList,
          routerList: val.routerList,
          userInfo: val.userInfo
        }
      }
    })
  ],
  state: {
    keepAliveInclude: [],
    selectedWorkList: {},
    examWorkList: {},
    classroomTaskList: {},  // 课堂任务专用清单（独立于 selectedWorkList）
    routerList: [],
    haveClass: '1',
    userInfo: {},
    firstLevelCompositionModuleId: sessionStorage.getItem('firstLevelCompositionModuleId')
  },
  getters: {
    isSuper(state) {
      return state.userInfo.roleType === 2
    },
    firstLevelCompositionModuleId(state) {
      return state.firstLevelCompositionModuleId
    }
  },
  mutations: {
    setFirstLevelCompositionModuleId(state, payload) {
      if (payload) {
        sessionStorage.setItem('firstLevelCompositionModuleId', payload)
      } else {
        sessionStorage.removeItem('firstLevelCompositionModuleId')
      }
      state.firstLevelCompositionModuleId = payload
    },
    haveClassChange: (state, val) => {
      state.haveClass = val
    },
    includeDel: (state, string) => {
      const index = state.keepAliveInclude.indexOf(string)
      if (index !== -1) {
        state.keepAliveInclude.splice(index, 1)
      }
    },
    includeAdd: (state, string) => {
      const index = state.keepAliveInclude.indexOf(string)
      if (index === -1) {
        state.keepAliveInclude.push(string)
      }
    },
    includeChange: (state, string) => {
      const index = state.keepAliveInclude.indexOf(string)
      if (index === -1) {
        state.keepAliveInclude.push(string)
      } else {
        state.keepAliveInclude.splice(index, 1)
      }
    },
    clearInclude: state => {
      state.keepAliveInclude = []
    },
    setUserInfo: (state, data = {}) => {
      state.userInfo = data
    },
    updateUserInfo: (state, data = {}) => {
      state.userInfo = { ...state.userInfo, ...data }
    },
    listAdd: (state, obj) => {
      let workList = obj.exam ? state.examWorkList : state.selectedWorkList
      const { id } = obj
      const newObj = {}
      newObj[id] = obj
      workList = Object.assign({}, workList, newObj)
      if (obj.exam) {
        state.examWorkList = workList
      } else {
        state.selectedWorkList = workList
      }
    },
    listDel: (state, obj) => {
      let workList = obj.exam ? state.examWorkList : state.selectedWorkList
      delete workList[obj.id]
      workList = Object.assign({}, workList)
      if (obj.exam) {
        state.examWorkList = workList
      } else {
        state.selectedWorkList = workList
      }
    },
    listClear: (state, type) => {
      if (type) {
        state.examWorkList = {}
      } else {
        state.selectedWorkList = {}
      }
    },
    // 课堂任务清单——添加单项
    classroomTaskAdd: (state, obj) => {
      const { id } = obj
      const newObj = {}
      newObj[id] = obj
      state.classroomTaskList = Object.assign({}, state.classroomTaskList, newObj)
    },
    // 课堂任务清单——删除单项
    classroomTaskDel: (state, obj) => {
      let workList = state.classroomTaskList
      delete workList[obj.id]
      state.classroomTaskList = Object.assign({}, workList)
    },
    // 课堂任务清单——清空
    classroomTaskClear: (state) => {
      state.classroomTaskList = {}
    },
    routerChange: (state, obj) => {
      if ((obj && obj.toName === 'transfer') || obj.name === 'transfer') {
        return
      }
      if (obj.name) {
        // 无名之辈，休想加入面包屑
        const routerList = state.routerList.map(item => item)
        // 将新来的路由添加到路由列表的最后
        routerList.push(obj)
        // 临时的路由列表
        let routerListTemp = []
        // 对路由列表进行遍历，并将符合条件的路由放至临时路由列表中
        for (let i = 0, len = routerList.length; i < len; i += 1) {
          // 解决问题：页面进行返回操作后，再次进入相同页面，路由重复的问题
          if (obj.toName === routerList[i].toName) {
            routerListTemp.push(routerList[i])
            break
          }
          // 解决问题：如果进入的页面跟当前路由一致，那么到当前位置即可，后面的路由也不需要了
          if (obj.toName === routerList[i].routerName) {
            break
          }
          // 符合条件的路由，放至临时路由列表中
          routerListTemp.push(routerList[i])
        }
        state.routerList = routerListTemp
      }
    },
    routerClear: state => {
      state.routerList = []
    }
  }
})
